module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_codou-503a30f126dd869eec9e9fe0c926a079.jpg";